type FilterRadioGroupProps = {
  title: string
  items: {
    value: string
    label: string
  }[]
  value: any
  handleChange: (...args: any[]) => void
  "data-testid"?: string
}

const FilterRadioGroup = ({
  title,
  items,
  value,
  handleChange,
  "data-testid": dataTestId,
}: FilterRadioGroupProps) => {
  return (
    <div className="flex gap-x-3 flex-col gap-y-3">
      <span className="text-sm font-medium text-grey-50">{title}</span>
      <div data-testid={dataTestId} className="flex flex-col gap-y-2">
        {items?.map((i) => (
          <div
            key={i.value}
            className="flex gap-x-2 items-center"
          >
            {i.value === value && (
              <span className="w-[6px] h-[6px] rounded-full bg-brand-primary shrink-0" />
            )}
            <input
              type="radio"
              checked={i.value === value}
              className="hidden"
              id={i.value}
              name={title}
              value={i.value}
              onChange={() => handleChange(i.value)}
            />
            <label
              htmlFor={i.value}
              className={`text-sm cursor-pointer transition-colors ${
                i.value === value
                  ? "text-brand-primary font-medium"
                  : "text-grey-50 hover:text-grey-90"
              }`}
              data-testid="radio-label"
              data-active={i.value === value}
            >
              {i.label}
            </label>
          </div>
        ))}
      </div>
    </div>
  )
}

export default FilterRadioGroup
